import { userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    refreshRequired: false
};

export const reducer = createReducer(initialState, {
    [userActions.forceRefreshRequest]: (state) => {
        state.refreshRequired = true;
    },
    [userActions.noRefresh]: (state) => {
        state.refreshRequired = false;
    },
})